import { render, staticRenderFns } from "./PromotionSendResearchersOffcanva.vue?vue&type=template&id=36b88c28&"
import script from "./PromotionSendResearchersOffcanva.vue?vue&type=script&lang=js&"
export * from "./PromotionSendResearchersOffcanva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports